/**
 * @author Jas
 * @email 83673@global.ul.com
 * @create date 2021-05-07
 * @desc activity tracker component (product classification)
 */
<template>
  <div class="activity-tracker-tabs">
    <div class="tabs-left">
      <ul class="nav nav-tabs" role="tablist">
        <li role="presentation" class="nav-item" :class="{active: tabActiveName=='rationales'}">
          <span class="nav-link" @click="tabClicked('rationales')" role="tab" data-toggle="tab">Rationale Reports ({{rationaleCount}})</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['rationaleCount', 'resetSearch', 'activeItem'],
  data() {
    return {
      tabActiveName: 'rationales',
    };
  },
  methods: {
    tabClicked(tab) {
      this.$emit('selectedMenu', tab);
    },
  },
  watch: {
    activeItem() {
      this.tabActiveName = this.activeItem;
    },
  },
};
</script>
